import { FC } from 'react';

import { Button, Dialog, DialogContent, Link, Typography } from '@mui/material';

interface AgencySupportDialogProps {
  open: boolean;
  onClose: () => void;
}

const supportEmail = 'support@911systems.com';

export const AgencySupportDialog: FC<AgencySupportDialogProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: '100%', maxWidth: 460 } }}
    >
      <DialogContent
        sx={{ bgcolor: 'background.paper', color: 'text.primary' }}
      >
        <Typography fontWeight={600} fontSize={18}>
          Please contact 911 Systems to create an agency
        </Typography>
        <Link
          href={`mailto:${supportEmail}`}
          sx={{ display: 'inline-block', mt: 0.5, fontSize: 16 }}
        >
          {supportEmail}
        </Link>
        <Button
          color="primary"
          variant="contained"
          onClick={onClose}
          sx={{
            mt: 3,
          }}
          fullWidth
        >
          Ok
        </Button>
      </DialogContent>
    </Dialog>
  );
};
